export default __webpack_public_path__ + "static/media/tap.1184336d.m4a";